<div class="main-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
  <mat-card appearance="outlined" style="margin-right: 0">
    <mat-card-title>Total Storage</mat-card-title>
    <mat-card-content>
      <div>
          <table class="table mt-4">
            <tbody>
            <tr>
              <th><strong>Retention Summary</strong></th>
              <td>{{companyPlansModel.totalRecordings | number:'1.2-2'}} Hours</td>
            </tr>
            <tr>
              <th><strong>Total SMS (Last 30 days)</strong></th>
              <td>{{companyPlansModel.totalSMS}}</td>
            </tr>
            <tr>
              <th><strong>Total Fax (Last 30 days)</strong></th>
              <td>{{companyPlansModel.totalFax}} pages</td>
            </tr>
            </tbody>
          </table>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined" fxFlex="50">
    <mat-card-title>{{currentRecordingsPlan.name}}</mat-card-title>
    <mat-card-content>
      <mat-form-field appearance="outline" class="regular-form-field">
        <mat-label>Set Limits For Recordings Retention</mat-label>
        <mat-select [(value)]="daysLimit" (valueChange)="onPlanLimitsChange($event)">
          <mat-option *ngFor="let item of maxDaysList" [value]="item.value">{{item.text}}</mat-option>
        </mat-select>
      </mat-form-field>
      <p class="pricing__item__features">
        {{currentRecordingsPlan.description}}
      </p>

      <button type="button" mat-raised-button color="primary"
              (click)="onRecordingsPlanChanged(currentRecordingsPlan)"
              *ngIf="planLimitsChanged"
              [promiseBtn]="payPlanSubmitPromise">Update Plan
      </button>
    </mat-card-content>
  </mat-card>
</div>
